import { Link } from 'react-router-dom';
import type { Movie } from '@/lib/movieTypes';
import MovieCard from '@/components/feature/MovieCard';

interface MovieGridSectionProps {
  title: string;
  subtitle?: string;
  movies: Movie[];
  moreTo?: string;
  moreLabel?: string;
  columns?: 4 | 5;
}

export default function MovieGridSection({
  title,
  subtitle,
  movies,
  moreTo,
  moreLabel = '查看全部',
  columns = 4,
}: MovieGridSectionProps) {
  const gridClass = columns === 5
    ? 'grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5'
    : 'grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5';

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-8">
      <div className="flex items-end justify-between gap-4 mb-5">
        <div className="flex items-center gap-3">
          <span className="w-1 h-7 rounded-full bg-accent-500"></span>
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">{title}</h2>
            {subtitle && <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{subtitle}</p>}
          </div>
        </div>
        {moreTo && (
          <Link
            to={moreTo}
            className="shrink-0 inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            {moreLabel}
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        )}
      </div>
      <div className={gridClass}>
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}